// src/components/MapboxMap.js
import React from 'react';
import { Map, NavigationControl } from 'react-map-gl/mapbox';
import { MAPBOX_TOKEN, MAPBOX_STYLE } from '../../../config';

const MapboxMap = ({ children, onFWIZoneHover , onMapLoad }) => {
  const [style, setStyle] = React.useState(MAPBOX_STYLE);

  const STREET_STYLE = 'mapbox://styles/mapbox/streets-v12';
  const HYBRID_STYLE = 'mapbox://styles/mapbox/satellite-streets-v12';
  const DARK_STYLE = 'mapbox://styles/mapbox/dark-v11';

  return (
    <>
      <div style={{ position: 'absolute', zIndex: 2, top: 10, right: 50 }}>
        <select value={style} onChange={e => setStyle(e.target.value)}>
          <option value={HYBRID_STYLE}>Satélite</option>
          <option value={STREET_STYLE}>Callejero</option>
          <option value={DARK_STYLE}>Oscuro</option>
        </select>
      </div>
      <Map
        initialViewState={{
          longitude: -0.50267,
          latitude: 39.53351,
          zoom: 13,
        }}
        style={{ width: '100%', height: '100%' }}
        mapStyle={style}
        mapboxAccessToken={MAPBOX_TOKEN}
        onLoad={(e) => {
          const mapInstance = e.target;
          if (onMapLoad) onMapLoad(mapInstance); // ← pasa el mapa hacia arriba
        }}
        interactiveLayerIds={[
          'fwi-zones-fill',
          'meeting-points-circle',
          'critical-population',
          'education-buildings-symbol',
          'elderly-homes',
          'emergency-circuits-line'
        ]}
        reuseMaps={true}
        onMouseMove={e => {
          const hoveredFeature = e.features[0];

          if (hoveredFeature) {
            const layerId = hoveredFeature.layer.id;

            // Mostrar tooltip si es FWI
            if (layerId === 'fwi-zones-fill') {
              const f = hoveredFeature;
              onFWIZoneHover?.({
                zoneName: f.properties?.Zona || 'Zona',
                riskIndex: f.properties?.riskIndex || 1,
                fwi: Math.round(f.properties?.fwi * 10) / 10 || 0
              });
            } else {
              onFWIZoneHover?.(null);
            }

            // Cambiar cursor a pointer si está sobre cualquier capa interactiva
            e.target.getCanvas().style.cursor = 'pointer';
          } else {
            onFWIZoneHover?.(null);
            e.target.getCanvas().style.cursor = '';
          }
        }}
      >

        <NavigationControl position="top-right" />
        {children}
      </Map>
    </>
  );
};

export default MapboxMap;
